import { render, staticRenderFns } from "./salesDispatchManagement.vue?vue&type=template&id=113112ef&scoped=true&"
import script from "./salesDispatchManagement.vue?vue&type=script&lang=js&"
export * from "./salesDispatchManagement.vue?vue&type=script&lang=js&"
import style0 from "./salesDispatchManagement.vue?vue&type=style&index=0&id=113112ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113112ef",
  null
  
)

export default component.exports